import React from 'react';

import OffersLayout1 from "./OffersLayout1/OffersLayout1";
import OffersLayout2 from "./OffersLayout2/OffersLayout2";
import OffersLayout3 from "./OffersLayout3/OffersLayout3";
import OffersLayoutBanner from "./OffersLayoutBanner/OffersLayoutBanner";

const OffersLayoutsManager = ({
    offer,
    categoryId,
    selectOfferById,
    openPopupInfo,
    noTimers,
    isBannerLayout,
    noQuantityCap
}) => {
    let OfferLayout = null;

    if (isBannerLayout) {
        return OfferLayout = <OffersLayoutBanner
            {...offer}
            selectOfferById={selectOfferById}
            openPopupInfo={openPopupInfo}
            noTimers={noTimers}
            noQuantityCap={noQuantityCap}
        />;
    }

    switch (offer.layout) {
        case 1: OfferLayout = <OffersLayout1
            {...offer}
            categoryId={categoryId}
            selectOfferById={selectOfferById}
            noTimers={noTimers}
            noQuantityCap={noQuantityCap}
        />;
            break;
        case 2: OfferLayout = <OffersLayout2
            {...offer}
            categoryId={categoryId}
            selectOfferById={selectOfferById}
            openPopupInfo={openPopupInfo}
            noTimers={noTimers}
            noQuantityCap={noQuantityCap}
        />;
            break;
        case 3: OfferLayout = <OffersLayout3
            {...offer}
            categoryId={categoryId}
            selectOfferById={selectOfferById}
            openPopupInfo={openPopupInfo}
            noTimers={noTimers}
            noQuantityCap={noQuantityCap}
        />;
            break;
    }

    return (
       OfferLayout
    );
};

export default OffersLayoutsManager;